import { set, get, reduce } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getPermission = get('permission');
export const getUserPermissions = createSelector(getPermission, get('all'));
export const getUserPermissionsAsMap = createSelector(
  getUserPermissions,
  reduce((all, key) => set(key, true, all), {})
);
export const getIsFetching = createSelector(getPermission, get('fetching'));
export const getIsFetched = createSelector(getPermission, get('fetched'));
export const getFetchingError = createSelector(
  getPermission,
  get('fetchingError')
);
